<script>
  import moment from "moment";
  import { stringify } from "query-string";
  import { navigate } from "svelte-routing";
  import { Head, Body, Row, Cell } from "@smui/data-table";
  import ResourceList from "../components/ResourceList.svelte";
  import { ResourceSelect, ResourceOption, Textfield } from "../components";
  import Checkbox from "@smui/checkbox";
  import FormField from "@smui/form-field";
  import { exclude } from "@smui/common/exclude.js";
  import Button, { Label, Icon } from "@smui/button";
  import { apiPost } from "../httpCommon";

  export let title;
  export let location;
  export let basePath = "/sales";
  export let vendorId = null;
  export let sale_date = moment().format("YYYY-MM-DD");
  title = "Sales by Day";

  let records;
  let list;
  let filter = { sale_date, 'payment_status': ['COMPLETED'] };
  let sort = [];
  let forVendor = vendorId !== null;
  let syncing = false;
  if (vendorId) {
    filter.vendor_id = vendorId;
  }

  $: props = exclude($$props, ["vendorId", "title"]);

  function changeFilter(event) {
    if (!event.target.name) {
      console.log("Filter name not set");
    } else {
      console.log("Change filter: ", event.target.name, event);
      if (event.target.value) {
        filter[event.target.name] = event.target.value;
      } else {
        delete filter[event.target.name];
      }
      list.refresh({ filter });
    }
  }

  async function syncPayments() {
    try {
      syncing = true;
      let query = `${basePath}/sync`;
      await apiPost(`${basePath}/sync`, filter);
      list.refresh();
    } finally {
      syncing = false;
    }
  }

  function setSort(col) {
    const [sortCol, sortDir] = sort;
    if (col != sortCol) {
      sort = [col, "asc"];
    } else {
      sort = [col, sortDir === "asc" ? "desc" : "asc"];
    }
    console.log(`Sort now: ${sort}`);
    list.refresh({ sort });
  }

</script>

<style>

</style>

{(console.log('SaleList.filter: ', filter), '')}
<ResourceList
  resource="sales"
  pageSize={50}
  bind:this={list}
  {location}
  bind:records
  {filter}
  {sort}
  {...props}>
  <div slot="filters" class="flex wrap no-spread">
    {#if !forVendor}
      <ResourceSelect
        input$name="vendor_id"
        on:change={changeFilter}
        bind:value={vendorId}
        resource="vendors"
        filter={{ has_sale: true }}
        nameField="vendor_name"
        label="Vendor" />
        &nbsp;
    {/if}
    <Textfield
      input$name="sale_date"
      type="date"
      value={filter.sale_date}
      on:change={changeFilter}
      label="Sale Date" />
  </div>
  <span slot="actions" let:loading>
    <Button on:click={syncPayments} class="create-button" disabled={syncing}>
      <Icon class="material-icons">replay</Icon>
      <Label>sync</Label>
    </Button>
  </span>
  <Head>
    <Row>
      <Cell class="pointer" on:click={() => setSort('sale_at')}>Sale Time</Cell>
      <Cell>
        Event No.
        <br />
        Invoice
      </Cell>
      {#if !forVendor}
        <Cell>
          Vendor
          <br />
          Venue
        </Cell>
      {/if}
      <Cell class="right">Amount</Cell>
      <Cell>Num Items</Cell>
    </Row>
  </Head>
  <Body>
    {#if records}
      {#each records as row}
        <Row>
          <Cell>
            {moment(row.sale_at).format('Do MMM')}
            <br />
            {moment(row.sale_at).format('HH:mm')}
          </Cell>
          <Cell>
            {row.event_no || '-'}
            <br />
            {row.invoice_ref || '-'}
          </Cell>
          {#if !forVendor}
            <Cell>
              {row.vendor_name || '-'}
              <br />
              {row.venue_name || '-'}
            </Cell>
          {/if}
          <Cell class="right">
            {row.total_amount}
            {#if row.discount_amount > 0}
            <br />
            (disc:{row.discount_amount})
            {/if}
          </Cell>
          <Cell>{row.sale_items.length}</Cell>
        </Row>
      {/each}
    {/if}
  </Body>
</ResourceList>
